import newHome from "@/components/newPages/Home/Home";
import Home_10013 from  "@/components/newPages/Home/Home_10013";
import HomeBar from "@/components/newPages/Home/HomeBar";
import newTable from "@/components/newPages/Home/newTable";
import newTable_10013 from "@/components/newPages/Home/newTable_10013";
import surfaces from "../components/teacher/Class/surfaces.vue";
import practiceSurfaces from "../components/teacher/Class/practiceSurfaces.vue";
import newPerson from "@/components/newPages/Home/newPerson";
import newMsg from "@/components/newPages/Home/newMsg";
import newMsg1 from "@/components/newPages/Home/newMsg_10013";
import newMsg_10488 from "@/components/newPages/Home/newMsg_10488";
import nod from "@/components/newPages/nodata";
const newIndexRoute = [
  {
    path: "/new/HomeBar",
    name: "HomeBar",
    component: HomeBar,
    redirect: "/new/Home",
    children: [
      {
        path: "/surfaces",
        name: "surfaces",
        component: surfaces,
        meta:{
          title:'教师课表'
        }
      },{
        path: "/practiceSurfaces",
        name: "practiceSurfaces",
        component: practiceSurfaces,
        meta:{
          title:'实践课程表'
        }
      },{
        path: "/new/Home",
        name: "newHome",
        component: newHome
      },
      {
        path: "/new/Home_10013",
        name: "Home_10013",
        component: Home_10013
      },

      {
        path: "/new/Table",
        name: "newTable",
        component: newTable
      },
      {
        path: "/new/newTable_10013",
        name: "newTable_10013",
        component: newTable_10013
      },
      {
        path: "/new/Person",
        name: "newPerson",
        component: newPerson
      },
      {
        path: "/new/Msg",
        name: "newMsg",
        component: newMsg
      },
      {
        path: "/new/Msg1",
        name: "newMsg1",
        component: newMsg1
      },
      {
        path: "/new/Msg_10488",
        name: "newMsg_10488",
        component: newMsg_10488
      }

    ]
  },
  {
    path: "/nod",
    name: "nod",
    component: nod,
  }
];
export default newIndexRoute;



// WEBPACK FOOTER //
// ./src/router/newIndex.js